import { GroupsList } from "../../features/groups/components/GroupsList";
import { useMemo, useState } from "react";
import { SearchInput } from "@components/ui/SearchInput";
import { useGroups } from "features/groups/customHooks/useGroups";
import { Button } from "@components/shadcn-ui/button";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";

export const GroupsListPage = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const { groups, isLoading } = useGroups();
    const navigate = useNavigate();

    const filteredGroups = useMemo(() => {
        // Ensure groups is an array before filtering
        if (!Array.isArray(groups)) {
            console.error('Groups is not an array:', groups);
            return [];
        }

        return groups.filter(({ name, city, coordinator }) => {
            const matchesSearch =
                name?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
                city?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
                coordinator?.contact?.firstName?.toLowerCase()?.includes(searchQuery.toLowerCase()) ||
                coordinator?.contact?.lastName?.toLowerCase()?.includes(searchQuery.toLowerCase());

            return matchesSearch;
        });
    }, [searchQuery, groups]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchQuery(e.target.value);
    };

    return (
        <div className="h-full flex-1 flex-col md:flex">
            <div className="flex flex-col md:flex-row md:items-center justify-between mb-3 gap-4 md:gap-0">
                <div>
                    <h2 className="text-2xl font-bold tracking-tight">Groups</h2>
                    <p className="text-muted-foreground">
                        Here&apos;s a list of all the Groups!
                    </p>
                </div>
                <Button
                    onClick={() => navigate("/dashboard/groups/create")}
                    className="bg-primary hover:bg-primary/90 w-full md:w-auto"
                >
                    <Plus className="h-4 w-4 mr-1" />
                    Create Group
                </Button>
            </div>
            <div className="flex flex-wrap items-center gap-1 px-0">
                <SearchInput
                    searchQuery={searchQuery}
                    handleSearchChange={handleSearchChange}
                    className="rounded-lg px-12 text-muted-foreground"
                />
            </div>
            <GroupsList
                searchQuery={searchQuery}
                filteredGroups={filteredGroups}
                isLoading={isLoading}
            />
        </div>
    );
};
